const mortgageProviders = [
  {
    dropdownValue: 1,
    displayName: 'No Mortgage'
  },
  {
    dropdownValue: 122,
    displayName: 'AIB'
  },
  {
    dropdownValue: 2021,
    displayName: 'Avant DAC t/a Avant Money'
  },
  {
    dropdownValue: 10045,
    displayName: 'Bank of Ireland Mortgages u.c'
  },
  {
    dropdownValue: 10054,
    displayName: 'Bank of Ireland (Broker Only)'
  },
  {
    dropdownValue: 10726,
    displayName: 'Dilosk DAC t/a ICS Mortgages'
  },
  {
    dropdownValue: 10005,
    displayName: 'EBS DAC'
  },
  {
    dropdownValue: 1977,
    displayName: 'Finance Ireland'
  },
  {
    dropdownValue: 1797,
    displayName: 'Haven Mortgage Limited'
  },
  {
    dropdownValue: 1390,
    displayName: 'PTSB'
  },
  {
    dropdownValue: 9938,
    displayName: 'Start Mortgages DAC'
  },
  {
    dropdownValue: 10047,
    displayName: 'MoCo (A Branch of BAWAG Bank)'
  },
  {
    dropdownValue: 10069,
    displayName: 'Nua Mortgages'
  },
  {
    dropdownValue: 1886,
    displayName: 'Pepper Finance'
  }
];

export default mortgageProviders;
